module.exports = __webpack_public_path__ + "static/media/close_template.ee421fe1.svg";